import { isManualOrExportSource } from './bookingSources';

/**
 * Airbnb-style confirmation / booking reference (e.g. HMYKK2QX43).
 * Mirrors backend ``confirmation_code_from_booking``.
 */
export function airbnbConfirmationCodeFromBooking(booking: {
  source?: string | null;
  external_booking_id?: string | null;
  reservation_url?: string | null;
  notes?: string | null;
  description?: string | null;
}): string {
  const src = String(booking.source || '').trim();
  const external = String(booking.external_booking_id || '').trim().toUpperCase();
  if (
    isManualOrExportSource(src) &&
    /^HA-[A-Z0-9]{5,12}$/i.test(external)
  ) {
    return external;
  }
  if (
    isManualOrExportSource(src) &&
    external &&
    !external.includes('@') &&
    !external.startsWith('IMPORTED-') &&
    /^[A-Z0-9]{8,14}$/.test(external)
  ) {
    return external;
  }
  const blob = `${booking.reservation_url || ''}\n${booking.notes || ''}\n${booking.description || ''}`;
  const m =
    blob.match(/\/reservations\/details\/([A-Z0-9]+)/i) ||
    blob.match(/\b(HM[A-Z0-9]{8,12})\b/i);
  return m ? m[1].toUpperCase() : '';
}
